import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { RoleGuard } from './components/auth/RoleGuard';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { syncQueue } from './lib/syncQueue';
import { useAuthStore } from './store/auth';
import { logger } from './lib/logger';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize sync queue
syncQueue.init().catch((error) => {
  logger.error('Failed to initialize sync queue', error);
});

// Initialize auth state from localStorage
useAuthStore.getState().initialize();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RoleGuard>
          <App />
        </RoleGuard>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);






